import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data.js'

let MERGE_TAGS = /** @type {const} */ ({
  medical_form_submitted: [
    {
      text: 'Has signature',
      type: 'menuitem',
      value: '{{medicalForm.hasSignature}}',
    },
    {
      text: 'General dentist - Full name',
      type: 'menuitem',
      value: '{{medicalForm.generalDentist.fullName}}',
    },
    {
      text: 'General dentist - Phone',
      type: 'menuitem',
      value: '{{medicalForm.generalDentist.phone}}',
    },
    {
      text: 'Physician - Full name',
      type: 'menuitem',
      value: '{{medicalForm.underCarePhysician.fullName}}',
    },
    {
      text: 'Physician - Phone',
      type: 'menuitem',
      value: '{{medicalForm.underCarePhysician.phone}}',
    },
    {
      text: 'Insurance - Subscriber employer',
      type: 'menuitem',
      value: '{{medicalForm.insurance.subscriberEmployer}}',
    },
    {
      text: 'Insurance - Owner',
      type: 'menuitem',
      value: '{{medicalForm.insurance.owner}}',
    },
    {
      text: 'Insurance - SSN',
      type: 'menuitem',
      value: '{{medicalForm.insurance.ssn}}',
    },
    {
      text: 'Insurance - Member ID',
      type: 'menuitem',
      value: '{{medicalForm.insurance.memberId}}',
    },
    {
      text: 'Insurance - Group number',
      type: 'menuitem',
      value: '{{medicalForm.insurance.groupNumber}}',
    },
    {
      text: 'Insurance - Carrier name',
      type: 'menuitem',
      value: '{{medicalForm.insurance.carrierName}}',
    },
    {
      text: 'Insurance - Carrier address',
      type: 'menuitem',
      value: '{{medicalForm.insurance.carrierAddress}}',
    },
    {
      text: 'Insurance - Carrier phone',
      type: 'menuitem',
      value: '{{medicalForm.insurance.carrierPhone}}',
    },
    {
      text: 'Insurance card',
      type: 'menuitem',
      value: '{{medicalForm.insurance.insuranceCard}}',
    },
    {
      text: 'Has insurance card',
      type: 'menuitem',
      value: '{{medicalForm.hasInsuranceCard}}',
    },
    {
      text: 'Has secondary insurance card',
      type: 'menuitem',
      value: '{{medicalForm.hasSecondaryInsuranceCard}}',
    },
    {
      text: 'Secondary insurance - Subscriber employer',
      type: 'menuitem',
      value: '{{medicalForm.insurance.secondary.subscriberEmployer}}',
    },
    {
      text: 'Secondary insurance - Owner',
      type: 'menuitem',
      value: '{{medicalForm.insurance.secondary.owner}}',
    },
    {
      text: 'Secondary insurance - SSN',
      type: 'menuitem',
      value: '{{medicalForm.insurance.secondary.ssn}}',
    },
    {
      text: 'Secondary insurance - Member ID',
      type: 'menuitem',
      value: '{{medicalForm.insurance.secondary.memberId}}',
    },
    {
      text: 'Secondary insurance - Group number',
      type: 'menuitem',
      value: '{{medicalForm.insurance.secondary.groupNumber}}',
    },
    {
      text: 'Secondary insurance - Carrier name',
      type: 'menuitem',
      value: '{{medicalForm.insurance.secondary.carrierName}}',
    },
    {
      text: 'Secondary insurance - Carrier address',
      type: 'menuitem',
      value: '{{medicalForm.insurance.secondary.carrierAddress}}',
    },
    {
      text: 'Secondary insurance - Carrier phone',
      type: 'menuitem',
      value: '{{medicalForm.insurance.secondary.carrierPhone}}',
    },
    {
      text: 'Heard about us from',
      type: 'menuitem',
      value: '{{medicalForm.heardAboutUsFrom}}',
    },
  ],
})

export default function useDataTransform(props, data) {
  let event_type = useDataValue({
    context: 'automation',
    path: 'event_type',
    viewPath: props.viewPath,
  })

  return useMemo(
    () =>
      event_type in MERGE_TAGS
        ? { ...data, items: MERGE_TAGS[event_type] }
        : null,
    [data, event_type]
  )
}
